import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ColumnDirective, ColumnsDirective, CommandColumn, Edit, GridComponent, Filter, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ToastUtility } from '@syncfusion/ej2-react-notifications';
import { Inject } from '@syncfusion/ej2-react-richtexteditor';
import React, { Component } from 'react';
import { confirm } from "react-confirm-box";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { getAuthToken } from '../helpers/authentication';
import { fieldRequired } from '../helpers/validation';
import '../helpers/date-prototypes';
import { CommandTemplate, ConfirmDialogStyles, SearchGridToolbar, LoadingSpinner } from '../helpers/Global';

export class Events extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      editData: [], loading: true, editModal: false, 
      id: 0,
      name: '',
      RegistrationStartDate: new Date(),
      RegistrationEndDate: new Date(),
      EventStartDate: new Date(),
      EventEndDate: new Date(), 

      status: 0,

    };
    this.toggle = this.toggle.bind(this);

  }

  toggle() {
    this.setState({
      editModal: !this.state.editModal
    });
  }

  componentDidMount() {
    document.title = "Events Administration";
    this.loadData();
  }

  //static toSystemDate = function (value) {
  //  var mm = value.getMonth() + 1 // getMonth() is zero-based
  //  var dd = value.getDate()

  //  return [value.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-')
  //}


  addItem = (ev) => { this.editItem(0); }

  editItem = (id) => {
    if (id > 0) {
      const data = this.state.editData.find((item) => { return item.id === id });
      console.log(data);
      //this.setState({ id: data.id, name: data.name, startDate: data.startDate, endDate: data.endDate, status: data.status, });
      this.setState({ id: data.Id, name: data.name, registrationStartDate: data.registrationStartDate, registrationEndDate: data.registrationEndDate, eventStartDate: data.eventStartDate, eventEndDate: data.eventEndDate, status: data.status, });
    }
    else {
      //clear state fields
      this.setState({
        id: 0,
        name: '',
        //startDate: new Date(),
        //endDate: new Date(),
        registrationStartDate: new Date(),
        registrationEndDate: new Date(),
        eventStartDate: new Date(),
        eventEndDate: new Date(), 

        status: 0,
      });
    }
    this.setState({ editId: id, editModal: true });
  };

  saveItem = async (event) => {
    event.stopPropagation();
    var valid = true;
    valid &= fieldRequired(this.state.name, 'tbNameError', '* required');
    //valid &= fieldRequired(this.state.startDate, 'tbStartDateError', '* required');
    //valid &= fieldRequired(this.state.endDate, 'tbEndDateError', '* required');
    console.log("saveItem", this.state.startDate);
    if (valid) {
      const data = this.state.editData.find((item) => { return item.id === this.state.editId });
      if (this.state.editId > 0) { //do not overwrite the following fie when updating
        this.setState({
          
          id: data.id,

        });
      }
      else {
        this.setState({
          status: 1
        });
      }
      this.saveData(this.state.editId);
      this.setState({ editModal: false });
    }
  }

  deleteItem = async (id) => {
    
    const result = await confirm("Are you sure you want to delete this item?", ConfirmDialogStyles);
    if (result) {
      this.deleteData(id);
    }
  }

  onGridCommand = (args) => {
    switch (args.commandColumn.type) {

      case 'Delete':
        this.deleteItem(args.rowData.id);
        break;
      default: //edit
        this.editItem(args.rowData.id);
        break;
    }
  }

  static renderDataTable(data, commandClick) {
    
    return (
      <GridComponent dataSource={data} ref={g => this.grid = g} allowFiltering={true} allowSorting={true} filterSettings={{ type: "Menu" }} commandClick={commandClick} toolbar={SearchGridToolbar} >
        <ColumnsDirective>
          <ColumnDirective field='name' width='75' headerText="Name" />
          <ColumnDirective field='registrationStartDate' width='50' headerText="Registration Start Date" type='dateTime' format="yyyy-MM-dd" />
          <ColumnDirective field='registrationEndDate' width='50' headerText="Registration End Date" type='dateTime' format="yyyy-MM-dd" />
          <ColumnDirective field='eventStartDate' width='50' headerText="Event Start Date" type='dateTime' format="yyyy-MM-dd" />
          <ColumnDirective field='eventEndDate' width='50' headerText="Event End Date" type='dateTime' format="yyyy-MM-dd" />
          <ColumnDirective headerText='Actions' width='30' commands={CommandTemplate} textAlign="right" />
        </ColumnsDirective>
        <Inject services={[Sort, Edit, CommandColumn, Filter, Toolbar]} />
      </GridComponent>
    );
  }

  taskDate(dateMilli) {
    console.log(dateMilli);
    var d = (new Date(dateMilli) + '').split(' ');
    d[2] = d[2] + ',';

    return [d[0], d[1], d[2], d[3]].join(' ');
  }

  render() {
    let contents = this.state.loading ? LoadingSpinner() : Events.renderDataTable(this.state.editData,  this.onGridCommand);

    return (
      <>
        <div className="container">
          <Row>
            <Col xs={6}>
              <h1>Events Administration</h1>
            </Col>
            <Col xs={6} className="text-end align-self-center">
              <Button color="primary" size="sm" onClick={this.addItem}>Add New <i className="fas fa-plus-circle ms-2"></i></Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              {contents}
            </Col>
          </Row>
        </div>

        <Modal isOpen={this.state.editModal} toggle={this.toggle} className={this.props.className} scrollable size="lg" backdrop="static">
          <ModalHeader toggle={this.toggle} close={<button className="close" onClick={this.toggle}><i className="fas fa-times"></i></button>}>Edit Events</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className='mb-3 col-23'>
                <TextBoxComponent id='tbName' name='tbName' placeholder='Name' type='text' maxLength='250' floatLabelType='Auto' showClearButton={true} value={this.state.name} onChange={e => this.setState({ name: e.target.value })} /> <div id='tbNameError' className='error-message' />
              </div>

              <div className='mb-3 col-md-3'>
                <DatePickerComponent id='tbRegistrationStartDate' name='tbRegistrationStartDate' placeholder='Registration Start Date' floatLabelType='Auto' showClearButton={true} format='yyyy-MM-dd' value={this.state.registrationStartDate} onChange={e => this.setState({ registrationStartDate: e.target.value })} /> <div id='tbRegistrationStartDateError' className='error-message' />
              </div>

              <div className='mb-3 col-md-3'>
                <DatePickerComponent id='tbRegistrationEndDate' name='tbRegistrationEndDate' placeholder='Registration End Date' floatLabelType='Auto' showClearButton={true} format='yyyy-MM-dd' value={this.state.registrationEndDate} onChange={e => this.setState({ registrationEndDate: e.target.value })} /> <div id='tbRegistrationEndDateError' className='error-message' />
              </div>

              <div className='mb-3 col-md-3'>
                <DatePickerComponent id='tbEventStartDate' name='tbEventStartDate' placeholder='Event Start Date' floatLabelType='Auto' showClearButton={true} format='yyyy-MM-dd' value={this.state.eventStartDate} onChange={e => this.setState({ eventStartDate: e.target.value })} /> <div id='tbEventStartDateError' className='error-message' />
              </div>

              <div className='mb-3 col-md-3'>
                <DatePickerComponent id='tbEventEndDate' name='tbEventEndDate' placeholder='Event End Date' floatLabelType='Auto' showClearButton={true} format='yyyy-MM-dd' value={this.state.eventEndDate} onChange={e => this.setState({ eventEndDate: e.target.value })} /> <div id='tbEventEndDateError' className='error-message' />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="dark" size="sm" onClick={this.toggle}>Cancel <i className="far fa-times-circle ms-2"></i></Button>
            <Button color="success" size="sm" onClick={this.saveItem}>Save <i className="far fa-check-circle ms-2"></i></Button>
          </ModalFooter>
        </Modal>
      </>

    );
  }

  async loadData() {

    var bearer = 'Bearer ' + getAuthToken();
    try {
      const response = await fetch('api/events', {
        method: 'GET',
        //withCredentials: true,
        //credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {

        const data = await response.json();
        console.log(data);
        this.setState({ editData: data, loading: false });
      }
      else {
        console.log(response.status + ": " + response.statusText);
        if (response.status === 401)
          this.props.history.push("/login");
      }

    } catch (e) {
      console.error(e);
    }
  }

  async saveData(dataId) {

    this.setState({ loading: true, showError: false, showSuccess: false });

    var bearer = 'Bearer ' + getAuthToken();
    console.log(this.state.startDate)
    //var data = { Id: this.state.id, Name: this.state.name, StartDate: this.state.startDate, EndDate: this.state.endDate, Status: 1 }
    var data = { Id: dataId, Name: this.state.name, RegistrationStartDate: this.state.registrationStartDate, RegistrationEndDate: this.state.registrationEndDate, EventStartDate: this.state.eventStartDate, EventEndDate: this.state.eventEndDate, Status: 1, }
    console.log(data)
    try {
      const response = await fetch('api/events', {
        method: dataId === 0 ? 'POST' : 'PUT',
        //withCredentials: true,
        //credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      });
      if (response.ok) {
        await response.json();
        this.loadData();
        ToastUtility.show({
          title: 'Events', content: 'The event was successfully saved!', timeOut: 5000, position: { X: 'Right', Y: 'Top' }, showCloseButton: true, cssClass: 'toast-success'
        });
      }
      else {
        console.log(response.status + ": " + response.statusText);
        if (response.status === 401)
          this.props.history.push("/login");
      }

    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
      ToastUtility.show({
        title: 'Events', content: 'There was an error saving the event!', timeOut: 5000, position: { X: 'Right', Y: 'Top' }, showCloseButton: true, cssClass: 'toast-danger'
      });
    }
  }

  async deleteData(dataId) {
    this.setState({ loading: true });

    var bearer = 'Bearer ' + getAuthToken();
    try {
      const response = await fetch('api/events/' + dataId, {
        method: 'DELETE',
        //withCredentials: true,
        //credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        await response.json();
        this.loadData();
        ToastUtility.show({
          title: 'Events', content: 'The events was successfully deleted!', timeOut: 5000, position: { X: 'Right', Y: 'Top' }, showCloseButton: true, cssClass: 'toast-success'
        });
      }
      else {
        console.log(response.status + ": " + response.statusText);
        if (response.status === 401)
          this.props.history.push("/login");
      }
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
      ToastUtility.show({
        title: 'Events', content: 'There was an error deleting the events!', timeOut: 5000, position: { X: 'Right', Y: 'Top' }, showCloseButton: true, cssClass: 'toast-danger'
      });
    }
  }
}

